<template>
  <div class="provider-list">
    <div class="row-titles">
      <p class="body">ชื่อ (ที่ใช้บน SAP)</p>
      <p class="body">ชื่อ (ที่ใช้บน APP)</p>
    </div>
    <provider-list-item
      v-for="item in data"
      :key="item.key"
      v-bind="item"
    ></provider-list-item>
  </div>
</template>

<script>
import ProviderListItem from "./ProviderListItem";

export default {
  components: {
    ProviderListItem,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.row-titles {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.body {
  flex: 1;
  text-align: left;
  padding: 10px 10px 10px 40px;
}

</style>
